import type {
  VariableSpeedDrivesQueryVariables,
  Variable_Speed_Drives_Bool_Exp
} from "gql/api";
import { Order_By } from "gql/api";

export function restoreVariableSpeedDrives(
  arr: Array<string>
): Variable_Speed_Drives_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export function deleteVariableSpeedDrives(
  arr: Array<string>
): Variable_Speed_Drives_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export const defaultVsdVars: VariableSpeedDrivesQueryVariables = {
  order_by: [{ prioritized_manufacturer: Order_By.Asc }]
};

export const adminVsdVars: VariableSpeedDrivesQueryVariables = {
  order_by: [{ prioritized_manufacturer: Order_By.Asc }]
};

export const kocVsdVars: VariableSpeedDrivesQueryVariables = {
  order_by: [{ prioritized_manufacturer: Order_By.Asc }],
  where: {
    _or: [
      { include_koc_timestamp: { _is_null: false } },
      { only_koc_timestamp: { _is_null: false } }
    ]
  }
};
export const ecopetrolVsdVars: VariableSpeedDrivesQueryVariables = {
  order_by: [{ prioritized_manufacturer: Order_By.Asc }],
  where: {
    _or: [
      { include_ecopetrol_timestamp: { _is_null: false } },
      { only_ecopetrol_timestamp: { _is_null: false } }
    ]
  }
};
